import { PDE } from "../../http/urls";

export const getAllDocuments = async () => {
  const res = await PDE.get("api/v1/featuredvideos");
  return res;
};
